export function getApiErrorField(error: any): string | undefined {
  if (!error || typeof error !== 'object') return undefined;
  const direct = error.field ?? error.field_key ?? error.key ?? error.name;
  if (direct) return String(direct);
  const location = error.loc ?? error.location ?? error.path;
  if (Array.isArray(location)) {
    const candidates = location.filter((part) => part != null && String(part) !== 'body' && String(part) !== 'query' && String(part) !== 'path');
    const last = candidates[candidates.length - 1];
    if (last != null && !/^\d+$/.test(String(last))) return String(last);
  }
  if (typeof location === 'string') {
    const parts = location.split(/[.\[\/]+/).filter(Boolean);
    return parts[parts.length - 1];
  }
  return undefined;
}

export function getApiErrorCode(error: any): unknown {
  return error?.code ?? error?.error_code ?? error?.type;
}

export function formatSubmissionError(detail: unknown): string {
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (!detail || typeof detail !== 'object') return 'Unable to submit the form.';
  const item = detail as { message?: unknown; detail?: unknown; errors?: unknown };
  const lines: string[] = [];
  if (typeof item.message === 'string' && item.message.trim()) lines.push(item.message.trim());
  if (typeof item.detail === 'string' && item.detail.trim() && item.detail !== item.message) lines.push(item.detail.trim());
  if (Array.isArray(item.errors)) {
    item.errors.forEach((error: any) => {
      if (!error || typeof error !== 'object') {
        if (String(error ?? '').trim()) lines.push(String(error));
        return;
      }
      const field = error.field ? ` (${String(error.field)})` : '';
      const message = error.message || error.msg || JSON.stringify(error);
      lines.push(`${String(message)}${field}`);
    });
  }
  if (!lines.length) {
    try { return JSON.stringify(detail, null, 2); } catch { return 'Unable to submit the form.'; }
  }
  return Array.from(new Set(lines)).join('\n');
}

export function getDataSourceError(error: unknown): string {
  const response = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  if (typeof response === 'string' && response.trim()) return response;
  if (response && typeof response === 'object' && 'message' in response) {
    const message = (response as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim()) return message;
  }
  return 'Unable to load data from the configured API.';
}
